import React, { useState, useEffect } from "react";

const S = {
  input:{width:"100%",background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:8,padding:"9px 13px",color:"#e8edf5",fontSize:13,outline:"none",boxSizing:"border-box"},
  btn:{color:"#fff",border:"none",borderRadius:10,padding:"10px 24px",fontSize:13,fontWeight:600,cursor:"pointer"},
  card:{background:"rgba(255,255,255,0.03)",border:"1px solid rgba(255,255,255,0.07)",borderRadius:12,padding:"16px"},
  ghost:{background:"rgba(255,255,255,0.07)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:8,color:"#aabbcc",cursor:"pointer",fontSize:12,padding:"7px 14px"},
};

export default function SaleStore({ user, onBack }) {
  const [tab, setTab] = useState("upload");
  const [stats, setStats] = useState(null);
  const [uploadMode, setUploadMode] = useState("process"); // process | store
  const [platform, setPlatform] = useState("amazon");
  const [files, setFiles] = useState([]);
  const [status, setStatus] = useState("idle");
  const [log, setLog] = useState([]);
  // Download
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selPlatforms, setSelPlatforms] = useState(["amazon","meesho"]);

  const addLog = (msg,type="info") => setLog(p=>[...p,{msg,type}]);

  useEffect(() => {
    fetch("/api/sales/stats").then(r=>r.json()).then(setStats).catch(()=>{});
  }, [tab]);

  const handleUpload = async () => {
    if (!files.length) return;
    setStatus("loading"); setLog([]);

    if (uploadMode === "process") {
      // Regular process & download
      addLog("Processing files...");
      const fd = new FormData();
      files.forEach(f => fd.append(platform === "amazon" ? "orders" : platform, f));
      const endpoint = platform === "amazon" ? "/api/generate" : platform === "meesho" ? "/api/meesho" : "/api/flipkart";
      try {
        const res = await fetch(endpoint, {method:"POST", body:fd});
        if (!res.ok) { const e=await res.json(); throw new Error(e.error); }
        const blob = await res.blob();
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a"); a.href=url; a.download=`${platform}_report.xlsx`; a.click();
        URL.revokeObjectURL(url);
        addLog("✅ Downloaded!", "success"); setStatus("done");
      } catch(e) { addLog("❌ "+e.message,"error"); setStatus("error"); }
    } else {
      // Store in DB
      addLog("Storing in database...");
      const fd = new FormData();
      files.forEach(f => fd.append(platform === "amazon" ? "orders" : "meesho", f));
      fd.append("username", user);
      const endpoint = platform === "amazon" ? "/api/sales/store-amazon" : "/api/sales/store-meesho";
      try {
        const res = await fetch(endpoint, {method:"POST", body:fd});
        const d = await res.json();
        if (!d.ok) throw new Error(d.error);
        addLog(`✅ Stored! ${d.added} new records added, ${d.skipped} duplicates skipped.`, "success");
        setStatus("done");
        fetch("/api/sales/stats").then(r=>r.json()).then(setStats).catch(()=>{});
      } catch(e) { addLog("❌ "+e.message,"error"); setStatus("error"); }
    }
  };

  const handleDownload = async () => {
    if (!startDate || !endDate) { addLog("Please select date range","error"); return; }
    setStatus("loading"); addLog("Generating report from database...");
    try {
      const res = await fetch("/api/sales/download", {
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body: JSON.stringify({startDate, endDate, platforms:selPlatforms, username:user}),
      });
      if (!res.ok) { const e=await res.json(); throw new Error(e.error); }
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a"); a.href=url; a.download="sales_report.xlsx"; a.click();
      URL.revokeObjectURL(url);
      addLog("✅ Downloaded!", "success"); setStatus("done");
    } catch(e) { addLog("❌ "+e.message,"error"); setStatus("error"); }
  };

  return (
    <div style={{minHeight:"100vh",background:"#0a0f1e",color:"#e8edf5",fontFamily:"'DM Sans',sans-serif"}}>
      <div style={{maxWidth:1000,margin:"0 auto",padding:"32px 16px"}}>
        <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:24}}>
          <button style={S.ghost} onClick={onBack}>← Dashboard</button>
          <div style={{color:"#4A9FD4",fontWeight:700,fontSize:18}}>📊 Sales Data Manager</div>
        </div>

        {/* Tabs */}
        <div style={{display:"flex",gap:8,marginBottom:24}}>
          {[["upload","⬆ Upload"],["download","⬇ Download from DB"],["log","📋 Upload Log"]].map(([id,label])=>(
            <button key={id} onClick={()=>setTab(id)}
              style={{padding:"8px 18px",borderRadius:20,border:"1px solid",cursor:"pointer",fontSize:13,fontWeight:600,
                background:tab===id?"rgba(74,159,212,0.2)":"rgba(255,255,255,0.04)",
                borderColor:tab===id?"#4A9FD4":"rgba(255,255,255,0.1)",
                color:tab===id?"#4A9FD4":"#8899aa"}}>{label}</button>
          ))}
        </div>

        {/* DB Stats */}
        {stats && (
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:20}}>
            {[
              {label:"📦 Amazon Orders", data:stats.amazon, color:"#FF9900"},
              {label:"🛍️ Meesho Orders",  data:stats.meesho,  color:"#F43397"},
            ].map(({label,data,color})=>(
              <div key={label} style={{background:`${color}10`,border:`1px solid ${color}33`,borderRadius:10,padding:"12px 16px"}}>
                <div style={{color,fontWeight:700,fontSize:13,marginBottom:4}}>{label}</div>
                {data?.total>0 ? (
                  <div style={{color:"#aabbcc",fontSize:12}}>
                    <span style={{color:"#e8edf5",fontWeight:700}}>{data.total?.toLocaleString()}</span> records · {data.min_date} to {data.max_date}
                  </div>
                ) : <div style={{color:"#667788",fontSize:12}}>No data stored yet</div>}
              </div>
            ))}
          </div>
        )}

        {tab==="upload" && (
          <div style={S.card}>
            {/* Mode selector */}
            <div style={{display:"flex",gap:10,marginBottom:20}}>
              {[["process","⚡ Process & Download","#4A9FD4"],["store","💾 Store in Database","#27AE60"]].map(([id,label,color])=>(
                <button key={id} onClick={()=>setUploadMode(id)}
                  style={{flex:1,padding:"12px",borderRadius:10,border:`2px solid ${uploadMode===id?color:"rgba(255,255,255,0.1)"}`,
                    background:uploadMode===id?`${color}18`:"transparent",color:uploadMode===id?color:"#8899aa",cursor:"pointer",fontSize:13,fontWeight:600}}>
                  {label}
                  <div style={{fontSize:10,marginTop:3,fontWeight:400,color:uploadMode===id?color+"cc":"#556677"}}>
                    {id==="process"?"Upload → process → download (nothing saved)":"Upload → save to DB → download anytime by date range"}
                  </div>
                </button>
              ))}
            </div>

            {/* Platform selector */}
            <div style={{marginBottom:16}}>
              <label style={{display:"block",color:"#8899aa",fontSize:12,marginBottom:8}}>Platform</label>
              <div style={{display:"flex",gap:8}}>
                {[["amazon","📦 Amazon",".txt","#FF9900"],["meesho","🛍️ Meesho",".csv","#F43397"],["flipkart","🛒 Flipkart",".xlsx","#2874F0"]].map(([id,label,ext,color])=>(
                  <button key={id} onClick={()=>{setPlatform(id);setFiles([]);}}
                    style={{padding:"7px 16px",borderRadius:16,border:`1px solid ${platform===id?color+"66":"rgba(255,255,255,0.1)"}`,
                      background:platform===id?`${color}18`:"transparent",color:platform===id?color:"#8899aa",cursor:"pointer",fontSize:12,fontWeight:600}}>
                    {label}
                  </button>
                ))}
              </div>
            </div>

            {/* File upload */}
            <label style={{display:"flex",flexDirection:"column",alignItems:"center",border:"2px dashed rgba(255,255,255,0.1)",borderRadius:10,padding:"24px",cursor:"pointer",marginBottom:16,textAlign:"center"}}>
              <input type="file" multiple accept={platform==="amazon"?".txt":platform==="flipkart"?".xlsx":".csv"} style={{display:"none"}}
                onChange={e=>setFiles(Array.from(e.target.files))}/>
              <div style={{fontSize:28,marginBottom:8}}>📁</div>
              <div style={{color:"#e8edf5",fontSize:13,fontWeight:600}}>Click to select files</div>
              <div style={{color:"#8899aa",fontSize:11,marginTop:4}}>{platform==="amazon"?"orders_jan.txt":platform==="meesho"?"Orders_YYYY-MM-DD.csv":"earn_more_report.xlsx"}</div>
            </label>

            {files.length>0&&(
              <div style={{marginBottom:16}}>
                {files.map((f,i)=><div key={i} style={{color:"#aaccdd",fontSize:11,padding:"3px 0"}}>✓ {f.name}</div>)}
              </div>
            )}

            <button style={{...S.btn,background:uploadMode==="store"?"linear-gradient(135deg,#1E8449,#27AE60)":"linear-gradient(135deg,#1A5276,#4A9FD4)",
              ...((!files.length||status==="loading")?{opacity:0.4,cursor:"not-allowed"}:{})}}
              onClick={handleUpload} disabled={!files.length||status==="loading"}>
              {status==="loading"?"⟳ Processing...":(uploadMode==="store"?"💾 Store in DB":"⚡ Process & Download")}
            </button>

            {log.length>0&&(
              <div style={{marginTop:16,background:"rgba(0,0,0,0.3)",borderRadius:8,padding:"12px",fontFamily:"monospace",fontSize:12}}>
                {log.map((l,i)=><div key={i} style={{color:l.type==="success"?"#4CAF82":l.type==="error"?"#FF6B6B":"#8BB8D4",marginBottom:2}}>› {l.msg}</div>)}
              </div>
            )}
          </div>
        )}

        {tab==="download" && (
          <div style={S.card}>
            <div style={{color:"#e8edf5",fontWeight:700,fontSize:14,marginBottom:16}}>Download Report from Stored Data</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:16}}>
              <div>
                <label style={{display:"block",color:"#8899aa",fontSize:12,marginBottom:6}}>Start Date</label>
                <input type="date" style={S.input} value={startDate} onChange={e=>setStartDate(e.target.value)}/>
              </div>
              <div>
                <label style={{display:"block",color:"#8899aa",fontSize:12,marginBottom:6}}>End Date</label>
                <input type="date" style={S.input} value={endDate} onChange={e=>setEndDate(e.target.value)}/>
              </div>
            </div>
            <div style={{marginBottom:16}}>
              <label style={{display:"block",color:"#8899aa",fontSize:12,marginBottom:8}}>Platforms</label>
              <div style={{display:"flex",gap:8}}>
                {[["amazon","📦 Amazon","#FF9900"],["meesho","🛍️ Meesho","#F43397"]].map(([id,label,color])=>(
                  <button key={id} onClick={()=>setSelPlatforms(p=>p.includes(id)?p.filter(x=>x!==id):[...p,id])}
                    style={{padding:"7px 16px",borderRadius:16,border:`1px solid ${selPlatforms.includes(id)?color+"66":"rgba(255,255,255,0.1)"}`,
                      background:selPlatforms.includes(id)?`${color}18`:"transparent",color:selPlatforms.includes(id)?color:"#8899aa",cursor:"pointer",fontSize:12,fontWeight:600}}>
                    {label} {selPlatforms.includes(id)?"✓":""}
                  </button>
                ))}
              </div>
            </div>
            <button style={{...S.btn,background:"linear-gradient(135deg,#1A5276,#4A9FD4)",...(status==="loading"?{opacity:0.4,cursor:"not-allowed"}:{})}}
              onClick={handleDownload} disabled={status==="loading"}>
              {status==="loading"?"⟳ Generating...":"⬇ Download Report"}
            </button>
            {log.length>0&&(
              <div style={{marginTop:16,background:"rgba(0,0,0,0.3)",borderRadius:8,padding:"12px",fontFamily:"monospace",fontSize:12}}>
                {log.map((l,i)=><div key={i} style={{color:l.type==="success"?"#4CAF82":l.type==="error"?"#FF6B6B":"#8BB8D4",marginBottom:2}}>› {l.msg}</div>)}
              </div>
            )}
          </div>
        )}

        {tab==="log" && (
          <div style={S.card}>
            <div style={{color:"#e8edf5",fontWeight:700,fontSize:14,marginBottom:14}}>Recent Uploads</div>
            {!stats?.log?.length ? (
              <div style={{color:"#667788",fontSize:13}}>No uploads logged yet.</div>
            ) : (
              <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
                <thead>
                  <tr>{["Platform","File","Added","Skipped","By","Date"].map(h=>(
                    <th key={h} style={{padding:"8px",background:"rgba(74,159,212,0.1)",color:"#8BB8D4",fontWeight:600,borderBottom:"1px solid rgba(255,255,255,0.08)",textAlign:"left"}}>{h}</th>
                  ))}</tr>
                </thead>
                <tbody>
                  {stats.log.map((l,i)=>(
                    <tr key={i} style={{borderBottom:"1px solid rgba(255,255,255,0.04)"}}>
                      <td style={{padding:"7px 8px",color:l.platform==="amazon"?"#FF9900":"#F43397",fontWeight:600}}>{l.platform}</td>
                      <td style={{padding:"7px 8px",color:"#aabbcc",maxWidth:200,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{l.filename}</td>
                      <td style={{padding:"7px 8px",color:"#27AE60",fontWeight:600}}>{l.records_added}</td>
                      <td style={{padding:"7px 8px",color:"#667788"}}>{l.records_skipped}</td>
                      <td style={{padding:"7px 8px",color:"#8899aa"}}>{l.uploaded_by}</td>
                      <td style={{padding:"7px 8px",color:"#667788"}}>{new Date(l.uploaded_at).toLocaleDateString("en-GB")}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
